const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M10 16.75a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5z"/><path fill-rule="evenodd" d="M6.9 2.75A2.15 2.15 0 0 0 4.75 4.9v14.2a2.15 2.15 0 0 0 2.15 2.15h10.2a2.15 2.15 0 0 0 2.15-2.15V4.9a2.15 2.15 0 0 0-2.15-2.15zM6.25 4.9a.65.65 0 0 1 .65-.65h10.2a.65.65 0 0 1 .65.65v14.2a.65.65 0 0 1-.65.65H6.9a.65.65 0 0 1-.65-.65z" clip-rule="evenodd"/></svg>';
export {
  a as w
};
